/**
 * Regular expression for ISO 8601 duration strings. It will also accept negative values to take delays like
 * infringements into account. It will also accept floating point values for seconds to enable milliseconds.
 *
 * This regex is a modified version of the one found at the following link:
 * @link https://stackoverflow.com/a/32045167
 * This implementation will therefore accept negative values and allow floating point values for seconds only.
 *
 * @example ISO_8601_DURATION_REGEX.test('P-1Y2M-3DT4H-5M-6.123S')
 * @type {RegExp}
 */
/* eslint-disable-next-line max-len */
const ISO_8601_DURATION_REGEX =
    /^-?P(?!$)(-?\d+(?:\d+)?Y)?(-?\d+(?:\d+)?M)?(-?\d+(?:\d+)?W)?(-?\d+(?:\d+)?D)?(T(?=-?\d)(-?\d+(?:\d+)?H)?(-?\d+(?:\d+)?M)?(-?\d+(?:\.\d+)?S)?)?$/

/**
 * @typedef {string} ISO8601Duration
 */

/**
 * Create a propType being required or optional.
 *
 * @link https://github.com/facebook/react/issues/9125
 * @param {boolean} isRequired
 */
function createIsoDurationPropType(isRequired) {
    // The factory returns a custom prop type
    return function (props, propName, componentName) {
        const prop = props[propName]

        if (prop === undefined) {
            // Prop is missing
            if (isRequired) {
                // Prop is required but wasn't specified. Throw an error.
                return new Error(`Property '${propName}' is marked as required at '${componentName}' but was omitted`)
            }
            // Prop is optional. Do nothing.
        } else if (prop && !ISO_8601_DURATION_REGEX.test(prop)) {
            return new Error(`Invalid ISO 8601 duration property '${propName}' supplied to '${componentName}': ${prop}`)
        }
    }
}

// Using the factory, create two different versions of your prop type
export const iso8601DurationPropType = createIsoDurationPropType(false)
iso8601DurationPropType.isRequired = createIsoDurationPropType(true)
